import React from 'react';
import { Reveal } from './Reveal';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function TestimonialStrip() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-230" data-mp="i1yzvpn9jzfg">
      <div className="mx-auto max-w-6xl" data-id="element-231" data-mp="i3s839diyrpk">
        <Reveal className="text-center" data-id="element-232" data-mp="m2rb2ofp4eed">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-233" data-mp="m3sv3ieowb88">
            ⭐ Ciò che le persone <span className="text-sage" data-id="element-234" data-mp="19u6iuwq8rnx0">dicono</span>
          </h2>
          <p className="mt-4 text-slate" data-id="element-235" data-mp="1eshoswdf1e9y">
            Persone che hanno finalmente compreso la loro storia — e hanno smesso di vivere quella di qualcun altro.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-236" data-mp="151wvnogih1yf">
          {testimonials.map((item, index) => <Reveal key={item.initials} delay={index * 0.05} className="h-full" data-id="element-237" data-mp="1sr7mad45dfyu" data-mpi={index}>
              <TestimonialCard item={item} className="p-8" data-id="element-238" data-mp="1xifzlk8lllha" />
            </Reveal>)}
        </div>
      </div>
    </section>;
}